<template>
  <div class='DevOps'>
    <div class='mb20'>
      <h3>水路运输计划</h3>
      <el-divider />
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("voyageNumber")'>
        开放航次
      </el-button>
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("voyageNumberClose")'>
        关闭航次
      </el-button>
    </div>
    <div class='mb20'>
      <h3>月度考核维护</h3>
      <el-divider />
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("assignSuppliers")'>
        分配供应商
      </el-button>
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("assignBrand")'>
        分配品牌
      </el-button>
    </div>
    <div class='mb20'>
      <h3>手持机维护</h3>
      <el-divider />
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("uploadPackage")'>
        上传手持机安装包
      </el-button>
      <el-button type='primary' size='medium' class='ml10' @click='btnClick("uploadPackageAPPRef")'>
        上传APP安装包
      </el-button>
    </div>
    <div class='mb20'>
      <h3>大屏维护</h3>
      <el-divider />
      <el-button type='primary' size='medium' class='ml10'
                 @click='btnClick("largeScreenMaintenance")'>
        大屏维护
      </el-button>
    </div>

<!--    <div class='mb20'>-->
<!--      <h3>委托车逆向导入</h3>-->
<!--      <el-divider />-->
<!--      <el-upload-->
<!--        ref='upload'-->
<!--        class='upload-demo'-->
<!--        :action='uploadUrl'-->
<!--        :auto-upload='true'-->
<!--        :show-file-list='false'-->
<!--        :data='uploadData'-->
<!--        :on-success='planOnSuccess'-->
<!--        :before-upload='beforeUpload'-->
<!--      >-->
<!--        <i class='el-icon-upload el-icon&#45;&#45;right'>表格导入</i>-->
<!--      </el-upload>-->
<!--    </div>-->
    <!-- 水路运输计划 START -->
    <!-- 开放航次 -->
    <voyage-number ref='voyageNumberRef' />
    <!-- 水路运输计划 END -->

    <!-- 月度考核维护 START -->
    <!-- 分配供应商 -->
    <assign-suppliers ref='assignSuppliersRef' />
    <!-- 分配供应商 -->
    <assign-brand ref='assignBrandRef' />
    <!-- 月度考核维护 END -->

    <!-- 手持机维护 START -->
    <!-- 上传手持机安装包 -->
    <upload-package ref='uploadPackageRef' upload-type="1" />
    <!-- 上传app安装包 -->
    <UploadPackageAPP ref='uploadPackageAPPRef' upload-type="2"/>
    <!-- 手持机维护 END -->

    <!-- 大屏维护 START -->
    <!-- 大屏维护 -->
    <large-screen-maintenance ref='largeScreenMaintenanceRef' />
    <!-- 大屏维护 END -->
  </div>
</template>

<script>
  import VoyageNumber from '@/views/DevOps/voyage-number/index';
  import AssignSuppliers from '@/views/DevOps/assign-suppliers/index';
  import AssignBrand from '@/views/DevOps/assign-brand/index';
  import UploadPackage from '@/views/DevOps/upload-package/index';
  import UploadPackageAPP from '@/views/DevOps/upload-package/index';
  import LargeScreenMaintenance from '@/views/DevOps/largeScreenMaintenance/index';
  import { getImport } from '@/service/getIP';
  export default {
    data(){
        return{
          importLoading: false,
          uploadUrl: '',  // 导入路径
          uploadData: {
            mFile: '',
          },
        }
    },
    name: 'index',
    components: {
      VoyageNumber,
      AssignSuppliers,
      AssignBrand,
      UploadPackage,
      UploadPackageAPP,
      LargeScreenMaintenance,
    },
    mounted() {
      // let token = getSessionStore('token');
      // this.uploadUrl  = baseUrl +`/platform/entryPort/entryPortExcel?access_token=${token}`
      this.uploadUrl = getImport('/platform/maintain/batchExportEntrustedVehicleReverse');
    },
    methods: {
      // 开放航次
      btnClick(str) {
        switch (str) {
          case 'voyageNumber':
            this.$refs.voyageNumberRef.openDialog('开放航次');
            break;
          case 'voyageNumberClose':
            this.$refs.voyageNumberRef.openDialog('关闭航次');
            break;
          case 'assignSuppliers':
            this.$refs.assignSuppliersRef.openDialog();
            break;
          case 'assignBrand':
            this.$refs.assignBrandRef.openDialog();
            break;
          case 'uploadPackage':
            this.$refs.uploadPackageRef.openDialog();
            break;
          case 'uploadPackageAPPRef':
            this.$refs.uploadPackageAPPRef.openDialog();
            break;
          case 'largeScreenMaintenance':
            this.$refs.largeScreenMaintenanceRef.openDialog();
            break;
        }
      },
      // 表格导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        // this.TableDatas = res.data;
        // this._vehicleDeployInfoCvPortList();
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._vehicleDeployInfoCvPortList();
          },
        });
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
    },
  };
</script>

<style lang='scss' scoped>
  .DevOps {
    padding: 20px;
    height: 96%;
  }

  .el-divider--horizontal {
    margin: 16px 0;
    height: 3px;
  }

  .el-divider {
    background-color: #487dd0;
  }
</style>
